import { CommonModule } from '@angular/common';
import * as i0 from "@angular/core";
export class AllEconomicDataModule {
}
AllEconomicDataModule.ɵfac = function AllEconomicDataModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AllEconomicDataModule)(); };
AllEconomicDataModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AllEconomicDataModule });
AllEconomicDataModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule] });
